import { render, staticRenderFns } from "./empleado_proveedor.vue?vue&type=template&id=5e80adb6"
import script from "./empleado_proveedor.vue?vue&type=script&lang=js"
export * from "./empleado_proveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports